<template>
  <a-form-item :label="data.fieldname">
    <a-checkbox-group
      v-decorator="[`${data.fieldkey}`, {
        rules: [{ required: data.isneeded === 1 ? true : false, message: placeholder }]
      }]"
      :value="defaultValue"
      @change="onChange"
    >
      <a-checkbox
        v-for="item in options"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-checkbox>
    </a-checkbox-group>
  </a-form-item>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      defaultValue: []
    }
  },
  computed: {
    options () {
      let { fieldtype, options = [], fieldconfig = {} } = this.data
      const { type } = fieldconfig
      if (fieldtype === 'radioinfo_level') {
        options = this.LevelOption(options, type)
      }
      return options
    }
  },
  watch: {
    data: {
      handler (val) {
        if (val) {
          let { fieldvalue = [] } = val || {}
          this.defaultValue = fieldvalue
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
  },
  methods: {
    onChange (val) {
      this.$emit('change', val)
    },
    LevelOption (options, type) {
      let arr = []
      if (type === 1) {
        arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G']
      } else if (type === 2) {
        arr = this.$t('message["1444"]').split(',')
      }
      options.forEach((item, index) => {
        arr.forEach((code, i) => {
          if (index === i) {
            item.name = code
          }
        })
      })
      return options
    }
  }
}
</script>

<style>
</style>
